import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
    providedIn: 'root'
})
export class PortalReportingService {
    private readonly portalReportingUrl: string;

    constructor(private readonly http: HttpClient) {
        this.portalReportingUrl = environment.backendPortalUri + 'Reporting.WebAPI/';
    }

    /**
     * Adds an action using the portal reporting API
     * @param action Action user made
     * @returns void
     */
    public addAction(action: string, data: string): Observable<void> {
        const url = this.portalReportingUrl + 'ApplicationUsages/Add';

        action = action + ' (' + environment.environmentName + ')';

        const payload: any = {
            ApplicationId: 592,
            Action: action,
            Data: data
        }

        return this.http.post<void>(url, payload);
    }
}